module.exports = __webpack_public_path__ + "img/1.f9153a4b.png";